import { render, staticRenderFns } from "./FinishV2.vue?vue&type=template&id=d3006008&scoped=true"
import script from "./FinishV2.vue?vue&type=script&lang=ts"
export * from "./FinishV2.vue?vue&type=script&lang=ts"
import style0 from "./FinishV2.vue?vue&type=style&index=0&id=d3006008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3006008",
  null
  
)

export default component.exports